<template>
  <div ref="tabsContainer" class="tabs is-centered" :class="{'ios-fix' : isTabFix, 'no-print' : $isIsef}">
    <ul :class="{'fixed-position' : isTabFix}">
      <li v-for="tab in this.pickTabs" :key="tab.name" @click="select(tab.name)" :class="{'is-active': currentTab === tab.name, 'is-disabled': isDisabled }">
        <a :class="'gtm-my-projects-'+ tab.label.toLowerCase() +'-tab'">
          <span>{{ displayLabel(tab) }}</span>
          <sup class="submenu-count " :class="'gtm-my-projects-'+ tab.label.toLowerCase() +'-tab'">{{ projectCounts[tab.countKey] }}</sup>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import breakpoints from '@/libs/breakpoints'
import i18n from '@/i18n'

export default {
  props: {
    projectCounts: {
      type: Object
    },
    showJudgeProjectTab: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tabs: [
        { name: 'viewall', label: 'All', countKey: 'all', jsonStr: 'viewAll.all' },
        { name: 'toBeJudged', label: 'TobeJudged', countKey: 'toBeJudged', jsonStr: 'viewAll.tobeJudged' },
        { name: 'private', label: 'Private', countKey: 'private', jsonStr: 'viewAll.private' },
        { name: 'public', label: 'Public', countKey: 'public', jsonStr: 'viewAll.public' },
        { name: 'anonymous', label: 'Anonymous', countKey: 'anonymous', jsonStr: 'viewAll.anonymous' },
        { name: 'templates', label: 'Templates', countKey: 'templates', jsonStr: 'viewAll.templates' }
      ],
      submissionTabs: [
        { name: 'pending', label: 'Pending', countKey: 'pending', jsonStr: 'viewAll.pending' },
        { name: 'declined', label: 'Declined', countKey: 'declined', jsonStr: 'viewAll.declined' },
        { name: 'approved', label: 'Approved', countKey: 'approved', jsonStr: 'viewAll.approved' }
      ],
      sigmaxiSubmissionTabs: [
        { name: 'pending', label: 'Pending', countKey: 'pending', jsonStr: 'viewAll.pending' },
        { name: 'resubmitted', label: 'Resubmitted', countKey: 'resubmitted', jsonStr: 'viewAll.resubmitted' },
        { name: 'declined', label: 'Declined', countKey: 'declined', jsonStr: 'viewAll.declined' },
        { name: 'approved', label: 'Approved', countKey: 'approved', jsonStr: 'viewAll.approved' }
      ],
      isefSubmissionTabs: [
        { name: 'submitted', label: 'Submitted', countKey: 'submitted', jsonStr: 'viewAll.submitted' },
        { name: 'resubmitted', label: 'Resubmitted', countKey: 'resubmitted', jsonStr: 'viewAll.resubmitted' },
        { name: 'declined', label: 'Declined', countKey: 'declined', jsonStr: 'viewAll.declined' },
        { name: 'approved', label: 'Approved', countKey: 'approved', jsonStr: 'viewAll.approved' }
      ],
      isTabFix: false,
      savedTabSelection: null,
      currentTab: 'viewall'
    }
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    showMySubmissions: function () {
      return this.$route.query.profile && this.$route.query.profile === 'submissions'
    },
    pickTabs: function () {
      if (this.showMySubmissions && this.$isIsef) {
        return this.isefSubmissionTabs
      } else if (this.showMySubmissions && this.$isSigmaXi) {
        return this.sigmaxiSubmissionTabs
      } else if (this.showMySubmissions && !this.$isIsef) {
        return this.submissionTabs
      }
      if (!this.showJudgeProjectTab) {
        return this.tabs.filter((tab) => tab.name !== 'toBeJudged')
      }
      return this.tabs
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.shouldFixTabBoard)
    this.initialCurrentTab()
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.shouldFixTabBoard)
  },
  methods: {
    select: function (tab) {
      if (this.isDisabled) {
        return
      }

      this.currentTab = tab
      this.$emit('refresh', tab)
    },
    shouldFixTabBoard: function () {
      const rect = this.$refs.tabsContainer.getBoundingClientRect()
      this.isTabFix = rect.top < 52
    },
    displayLabel: function (tab) {
      return i18n.t(tab.jsonStr)
    },
    initialCurrentTab: function () {
      // Check submissions
      if (this.showMySubmissions) {
        // ISEF
        if (this.$isIsef || this.$isSigmaXi) {
          this.currentTab = 'submitted'
        } else {
          this.currentTab = 'viewall'
        }
      } else {
        // defaults
        this.currentTab = 'viewall'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.tabs {
  margin-top:1.5rem;
  overflow-y: hidden;
  overflow-x: auto;
  @include mobile {
    margin: 0.5rem 0;
  }

  ul {
    border-bottom-width: 1px;
    transition: 0.25s all;
    a {
      position:relative;
      span{
        margin-right:1px;
        font-size: 0.9rem;
      }
    }

    @include mobile{
      font-size: 0.8em;
      border-top: 1px solid #dbdbdb;

      a {
        padding:0.5em 0.8em;
      }
    }
  }
}

.fixed-position {
  position: fixed;
  top: $navbar-height;
  right: 0;
  left: 0;
  z-index: 10;
  overflow-x: auto;
  overflow-y: hidden;
  background: rgba(242,242,242,0.9);
}

.submenu-count{
    font-size: 0.7rem;
    color: $secondary;
    margin-top:-11px;
    @include mobile{

    }
}

.is-active {
  a {
    border-bottom-color: $secondary;
  }
}

.is-disabled {
  a {
    color: grey;
    cursor: not-allowed;
  }
}

.is-isef a{
  color: white;
  .submenu-count {
    color: white;
  }
}

.is-isef li.is-active a {
  color: white;
  font-weight: bold;
}

.ios-fix{
  overflow:hidden;
}

</style>
